class setBlueBlock {
  _constructor() {
    this.$block = document.querySelector('.blue-bg-block')
  }

  _setWitdh() {
    let w = (window.innerWidth > 1200) ? (window.innerWidth - ((window.innerWidth - 1200) / 2)) + 'px' : 100 + '%'
    this.$block.style.width = w
  }

  init() {
    this._constructor()
    const self = this
    let resizeTimer

    this._setWitdh()

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(function() {
        self._setWitdh()
      }, 250)
    })
  }
}
export default setBlueBlock
